module.exports = __webpack_public_path__ + "static/media/djewp.a1dfd63b.jpg";